import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
import StimulusReflex from "stimulus_reflex";
export default class extends ApplicationController {
  static targets = ["hm0_output", "sidebar", "body"];

  connect() {
    super.connect();
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      //this.show_edition_multiple();
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
    }
    MicroModal.init();
    this.handleSidebarScroll("cra_mensuel_");
  }

  show_edition_multiple() {
    if (this.current_app && this.params) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/cra_mensuels/show_ajax_edition_multiple?filtrage=" +
        this.params +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#edition_multiple").html("");
          $("#edition_multiple").html(text);
          MicroModal.init();
        }),
      );
    }
  }

  quick_cra_normal_recalc(event) {
    this.stimulate("CraMensuels#quick_cra_normal_recalc", event.currentTarget);
  }
  etaler_temps(event) {
    let imput_id_model = $("#target_temps").val();
    let time_value = $("#quantite").val();
    let element_to_fire;
    let elements_to_fill = $("[id^='remplir_ts']");
    elements_to_fill.each(function (index) {
      if (elements_to_fill[index].value == "1") {
        var id_contsruct = elements_to_fill[index].id.split("remplir_")[1];
        id_contsruct = id_contsruct + imput_id_model;
        var elements = $("[id^='" + id_contsruct + "']");
        elements.each(async function (i) {
          const td = elements[i].closest("td");
          const tdStyle = td ? td.getAttribute("style") || "" : ""; // ← null-safe
          if (
            !elements[i].id.includes("commentaires") &&
            elements[i].type != "hidden" &&
            (!tdStyle.includes("background-color") ||
              (tdStyle.includes("background-color") &&
                tdStyle.includes("orange")))
          ) {
            elements[i].value = time_value;
            element_to_fire = elements[i];
            element_to_fire.dispatchEvent(new Event("input"));
            await new Promise((r) => setTimeout(r, 100));
          }
        });
      }
    });
    MicroModal.close("etaler_temps");
  }

  search(event) {
    const table_id = event.target.dataset.table_id;
    const input_id = event.target.dataset.input_id;
    const input = document.getElementById(input_id);
    const filter = input.value.toUpperCase();
    const container = document.getElementById(table_id);
    const chips = container.querySelectorAll("label.chip");

    chips.forEach((chip) => {
      const txtValue = chip.textContent || chip.innerText;
      chip.style.display = txtValue.toUpperCase().includes(filter)
        ? ""
        : "none";
    });
  }

  hide_show_all(event) {
    var crs_ids = eval(event.target.dataset.crs_ids);
    var doms_crs_ids = eval(event.target.dataset.doms_crs_ids);
    var act_ids = eval(event.target.dataset.act_ids);
    var self = this;
    for (let i = 0; i < crs_ids.length; i++) {
      setTimeout(function () {
        (self.check_uncheck(crs_ids[i], "crs", null, 1), 100);
      });
    }
    for (let i = 0; i < doms_crs_ids.length; i++) {
      setTimeout(function () {
        (self.check_uncheck(doms_crs_ids[i][0], "dom", doms_crs_ids[i][1], 1),
          100);
      });
    }
    for (let i = 0; i < act_ids.length; i++) {
      setTimeout(function () {
        (self.check_uncheck(act_ids[i], "act", null, 1), 100);
      });
    }
    var element_to_fire = $("#quick_cra input[data-action][id*='ts']").first();
    if (element_to_fire.length > 0) {
      element_to_fire[0].dispatchEvent(new Event("input"));
    } else {
      this.stimulate(
        "CraMensuels#quick_cra_normal_recalc",
        event.currentTarget,
      );
    }
  }

  check_uncheck(id, type, id_bis = null, all = null) {
    if (type == "crs") {
      var val = $("#check_crs_" + id).prop("checked");
      if (!val) {
        $("#check_crs_" + id).click();
      }
    }
    if (type == "dom") {
      var val = $("#check_crs_" + id + "_dom_" + id_bis).prop("checked");
      $("#check_crs_" + id).prop("checked", true);
      if (!val) {
        $("#check_crs_" + id + "_dom_" + id_bis).click();
      }
    }
    if (type == "act") {
      var val = $("#check_act_" + id).prop("checked");
      if (!val) {
        $("#check_act_" + id).click();
      }
    }
  }

  hide_show(event) {
    var id = event.target.dataset.id;
    var type = event.target.dataset.type;
    var id_bis = event.target.dataset.id_bis;
    var all = event.target.dataset.all;
    if (type == "crs") {
      var elements = $("[id$='_" + id + "'][id^='tsid']");
      if (elements.is(":visible")) {
        elements.toggle("slow");
        //set element values to 0 (elements is a tr containing td with input type text)
        elements.each(function () {
          $(this).find("td").each(function () {
            $(this).find("input[type='text']").val(0);
          });
        });
      } else {
        elements.toggle("slow");
      }
    }
    if (type == "dom") {
      var elements = $("[id$='_" + id + "_dom_" + id_bis + "'][id^='tsid']");
      var parent_element = $("[id$='tsid_" + id + "'][id^='tsid']");
      if (elements.is(":visible")) {
        elements.toggle("slow");
        //set element values to 0
        elements.each(function () {
          this.value = 0;
        });
      } else {
        elements.toggle("slow");
        parent_element.show();
        $("#check_crs_" + id).prop("checked", true);
      }
      setTimeout(function () {
        var all_elements_visible = $("[id^='tsid_" + id + "_dom_']").is(
          ":visible",
        );
        if (all_elements_visible) {
          parent_element.show();
          $("#check_crs_" + id).prop("checked", true);
        } else {
          parent_element.hide();
          $("#check_crs_" + id).prop("checked", false);
        }
      }, 900);
    }
    if (type == "act") {
      elements = $("[id$='_" + id + "_act_type'][id^='tsid']");
      if (elements.is(":visible")) {
        elements.toggle("slow");
        //set element values to empty
        elements.each(function () {
          this.value = 0;
        });
      } else {
        elements.toggle("slow");
      }
    }
    if (!all) {
      // Retire la couleur des lignes précédemment surlignées
      $("tr").each(function () {
        if ($(this).css("background-color") === "rgb(255, 255, 204)") {
          this.style.setProperty("background-color", "", "important");
          $(this)
            .find("td")
            .each(function () {
              this.style.setProperty("background-color", "", "important");
              if (this.classList.contains("td-total")) {
                this.style.setProperty("color", "", "important");
              }
            });
        }
      });

      // Applique la couleur sur les nouvelles lignes
      elements.each(function () {
        this.style.setProperty(
          "background-color",
          "rgb(255, 255, 204)",
          "important",
        );
        $(this)
          .find("td")
          .each(function () {
            this.style.setProperty(
              "background-color",
              "rgb(255, 255, 204)",
              "important",
            );
            if (this.classList.contains("td-total")) {
              this.style.setProperty(
                "color",
                "var(--fx-primary-color)",
                "important",
              );
              this.style.setProperty("border-left", "none", "important");
            }
          });
      });
    }
    //setTimeout(function(){ elements.css("background","none")},3500);
  }
  scrolleft(event) {
    event.preventDefault();
    var pos = $("#container_cra").scrollLeft();
    pos = pos - 400;
    $("#container_cra").scrollLeft(pos);
  }
  scrolright(event) {
    event.preventDefault();
    var pos = $("#container_cra").scrollLeft();
    pos = pos + 400;
    $("#container_cra").scrollLeft(pos);
  }
  updateValue(event) {
    const id = event.target.dataset.id;
    const isChecked = event.target.checked;
    const label = event.target.closest("label");

    $("#remplir_" + id).val(isChecked ? 1 : "");

    if (label) {
      label.style.background = isChecked
        ? "var(--fx-primary-color)"
        : "#f8fafa";
      label.style.borderColor = isChecked
        ? "var(--fx-primary-color)"
        : "#dde8e8";
      label
        .querySelectorAll("span")
        .forEach((s) => (s.style.color = isChecked ? "white" : ""));
    }
  }

  checkAll(event) {
    const crs_id = event.currentTarget.dataset.crs_id;
    const selector = crs_id
      ? `[id^='checkbox_${crs_id}_']`
      : "[id^='checkbox_ts']";

    $(selector).each(function () {
      this.checked = true;
      $("#remplir_" + $(this).data("id")).val(1);
      const label = this.closest("label");
      if (label) {
        label.style.background = "var(--fx-primary-color)";
        label.style.borderColor = "var(--fx-primary-color)";
        label
          .querySelectorAll("span")
          .forEach((s) => (s.style.color = "white"));
      }
    });
  }

  uncheckAll(event) {
    const crs_id = event.currentTarget.dataset.crs_id;
    const selector = crs_id
      ? `[id^='checkbox_${crs_id}_']`
      : "[id^='checkbox_ts']";

    $(selector).each(function () {
      this.checked = false;
      $("#remplir_" + $(this).data("id")).val("");

      const label = this.closest("label");
      if (label) {
        label.style.background = "#f8fafa";
        label.style.borderColor = "#dde8e8";
        label.querySelectorAll("span").forEach((s) => (s.style.color = ""));
      }
    });
  }
  etaler_temps(event) {
    let imput_id_model = $("#target_temps").val();
    let time_value = $("#quantite").val();

    let elements_to_fill = $("[id^='remplir_ts']");
    elements_to_fill.each(function (index) {
      if (elements_to_fill[index].value == "1") {
        var id_contsruct = elements_to_fill[index].id.split("remplir_")[1];
        id_contsruct = id_contsruct + imput_id_model;

        var elements = $("[id^='" + id_contsruct + "']");
        elements.each(async function (i) {
          const td = elements[i].closest("td");
          const isWeekend = td ? td.classList.contains("weekend") : false;

          if (
            !elements[i].id.includes("commentaires") &&
            elements[i].type != "hidden" &&
            !isWeekend
          ) {
            elements[i].value = time_value;
            $(elements[i]).addClass("has-value");

            // Simule une vraie saisie utilisateur pour déclencher le reflex
            const nativeInputEvent = Object.assign(
              new Event("input", { bubbles: true, cancelable: true }),
              { simulated: true },
            );
            elements[i].dispatchEvent(nativeInputEvent);

            updateCommentBubble($(elements[i]));

            await new Promise((r) => setTimeout(r, 100));
          }
        });
      }
    });
    MicroModal.close("etaler_temps");
  }
  update_transfert(event) {
    this.stimulate("CraMensuels#updateTransfert", event.currentTarget);
  }
  refresh_pref(event) {
    var loader = document.getElementsByClassName("child-loader")[0];
    var elem = document.getElementById("cra_mensuels");
    elem.innerHTML = loader.innerHTML;
    this.stimulate("CraMensuels#refresh_pref", event.currentTarget);
  }
  fusion_ligne_domaine(event) {
    var loader = document.getElementsByClassName("child-loader")[0];
    var elem = document.getElementById("cra_mensuels");
    elem.innerHTML = loader.innerHTML;
    this.stimulate("CraMensuels#fusion_ligne_domaine", event.currentTarget);
  }
  pre_remplir_cra(event) {
    var loader = document.getElementsByClassName("child-loader")[0];
    var elem = document.getElementById("cra_mensuels");
    elem.innerHTML = loader.innerHTML;
    this.stimulate("CraMensuels#pre_remplir_cra", event.currentTarget);
  }
  beforePreRemplirCra(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "padding-top:200px;text-align:center");
  }
  afterPreRemplirCra(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "");
  }
  beforeRefreshPref(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "padding-top:200px;text-align:center");
  }
  afterRefreshPref(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "");
    $("#change_checkbox").prop(
      "checked",
      !$("#change_checkbox").prop("checked"),
    );
    $("#edit_button").show();
  }
  beforeFusionLigneDomaine(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "padding-top:200px;text-align:center");
  }
  afterFusionLigneDomaine(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "");
    $("#edit_button").show();
  }
  get params() {
    return this.data.get("params");
  }

  get entreprise_ids() {
    return this.data.get("entrepriseids");
  }

  get entreprise_id() {
    return this.data.get("entrepriseid");
  }

  get current_app() {
    return this.data.get("app");
  }

  get url_solution() {
    return this.data.get("urlsolution");
  }

  quickCraNormalRecalcSuccess(element) {
    if (document.getElementById("scrollevel_div")) {
      document.getElementById("container_cra").scrollLeft =
        document.getElementById("scrollevel_div").value;
    }
    // this.documentIsCrolled_()
  }
  getCurrentHeight(ids) {
    let height = 0;
    for (var i = 0; i < ids.length; i++) {
      if (document.getElementById(ids[i])) {
        height = height + document.getElementById(ids[i]).offsetHeight;
      }
    }
    return height;
  }

  beforeReflex(element, reflex, noop, reflexId) {
    if ($(".content-search")) {
      $(".content-search").select2({
        width: "resolve",
        placeholder: "",
        allowClear: true,
      });
    }
    MicroModal.init();
    this.changeColor();
  }
  afterReflex(element, reflex, noop, reflexId) {
    if ($(".content-search")) {
      $(".content-search").select2({
        width: "resolve",
        placeholder: "",
        allowClear: true,
      });
    }
    MicroModal.init();
    this.changeColor();
  }
  // Save a reference to the element that should receive focus
  reflexSuccess(element, reflex, noop, reflexId) {
    if ($(".content-search")) {
      $(".content-search").select2({
        width: "resolve",
        placeholder: "",
        allowClear: true,
      });
    }
    MicroModal.init();
    this.changeColor();
  }

  reflexError(element, reflex, error, reflexId) {
    if ($(".content-search")) {
      $(".content-search").select2({
        width: "resolve",
        placeholder: "",
        allowClear: true,
      });
    }
    MicroModal.init();
    this.changeColor();
  }
  documentIsCrolled_() {
    //Récupération des éléments html qu'on aimerait manipuler par le biais de leur ID
    let sticky = navbar.offsetTop;
    let simple_compotor = document.getElementById("simple_compotor");
    let fieldsets_section = document.getElementById("fieldsets_section");
    let field_section_28985 = document.getElementById("field_section_28985");
    if (window.pageYOffset >= sticky) {
      if (simple_compotor) {
        simple_compotor.style.padding = "10px";
        simple_compotor.style.marginLeft = "0px";
        simple_compotor.style.marginTop = "0";
        simple_compotor.style.backgroundColor = "white";
        simple_compotor.style.left = 0;
        simple_compotor.classList.add("sticky");
        simple_compotor.style.zIndex = "5";
      }
      if (fieldsets_section) {
        fieldsets_section.classList.add("sticky");
        fieldsets_section.style.left = 0;
        fieldsets_section.style.top =
          this.getCurrentHeight(["simple_compotor"]) - 7 + "px";
        fieldsets_section.style.backgroundColor = "white";
        fieldsets_section.style.zIndex = "5";
        fieldsets_section.style.paddingBottom = "15px";

        if (field_section_28985) {
          field_section_28985.style.marginBottom =
            this.getCurrentHeight(["fieldsets_section"]) - 90 + "px";
        }
      }
      // if (container_cra) {
      //   container_cra.classList.add("tableFixHead");
      //   container_cra.style.borderCollapse = "initial";
      //   container_cra.style.top =
      //     getCurrentHeight(["fieldsets_section"]) - 180 + "px";
      //   container_cra.style.zIndex = "5";
      // }
    } else {
      if (simple_compotor) {
        simple_compotor.classList.remove("sticky");
        simple_compotor.style.paddingTop = "unset";
        simple_compotor.style.backgroundColor = "unset";
        simple_compotor.style.marginTop = "unset";
        simple_compotor.style.marginLeft = "unset";
      }

      if (fieldsets_section) {
        fieldsets_section.classList.remove("sticky");
        fieldsets_section.style.top = "unset";
        fieldsets_section.style.backgroundColor = "unset";
        fieldsets_section.style.paddingBottom = "unset";

        if (field_section_28985) {
          field_section_28985.style.marginBottom = "unset";
        }
      }
    }
  }

  // Toggle sidebar droit
  toggleSidebar() {
    this.sidebarTarget.classList.toggle("collapsed");
  }

  // Toggle accordion section
  toggleSection(event) {
    const header = event.currentTarget;
    const body = header.nextElementSibling;
    const icon = header.querySelector(".missions-toggle-icon");
    const isOpen = icon.classList.contains("open");
    body.style.display = isOpen ? "none" : "flex";
    icon.classList.toggle("open", !isOpen);
  }

  // Toggle tout le bloc quick_form_choice_bis
  toggleAll(event) {
    const header = event.currentTarget;
    const icon = header.querySelector(".missions-toggle-icon");
    const isOpen = icon.classList.contains("open");
    const container = header.nextElementSibling;
    container.style.display = isOpen ? "none" : "block";
    icon.classList.toggle("open", !isOpen);
  }

  // Toggle chip (label + input caché)
  toggleChip(event) {
    event.preventDefault(); // ← stoppe le submit
    event.stopPropagation();

    const label = event.currentTarget;
    const input = label.querySelector("input[type='checkbox']");
    if (!input) return;

    
    //show a confirmation alert to confirm the action to disable active chip
    if (input.checked) {
      if (confirm("Est ce que vous voulez désactiver cette activité ? Les saisies en cours seront perdues.")) {
        input.checked = !input.checked;
        label.classList.toggle("active-chip", input.checked);
        // dispatch change pour cra-mensuel#hide_show
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    } else {
      input.checked = !input.checked;
      label.classList.toggle("active-chip", input.checked);
      // dispatch change pour cra-mensuel#hide_show
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}
